import { useLocation } from "react-router-dom";

export const useCanonicalUrl = () => {
  const location = useLocation();
  return "https://www.trust-doc.com" + location.pathname;
};
